<template>
	<div id="integral">
		<div class="integral_box">
			<h2>88888</h2>
			<span>积分总额</span>
		</div>
		<div class="jf_list">
			<ul>
				<li class="hd">
					<div class="box_left"> 
						<h3><span>获得</span>邀请新用户注册</h3>
						<i>2020-01-01 16:42</i>
					</div>
					<div class="box_right">+88</div>
				</li>
				<li class="xfei">
					<div class="box_left"> 
						<h3><span>消费</span>邀请新用户注册</h3>
						<i>2020-01-01 16:42</i>
					</div>
					<div class="box_right">+88</div>
				</li>
				<li class="hd">
					<div class="box_left"> 
						<h3><span>获得</span>邀请新用户注册</h3>
						<i>2020-01-01 16:42</i>
					</div>
					<div class="box_right">+88</div>
				</li>
				<li class="xfei">
					<div class="box_left"> 
						<h3><span>消费</span>邀请新用户注册</h3>
						<i>2020-01-01 16:42</i>
					</div>
					<div class="box_right">+88</div>
				</li>
				<li class="hd">
					<div class="box_left"> 
						<h3><span>获得</span>邀请新用户注册</h3>
						<i>2020-01-01 16:42</i>
					</div>
					<div class="box_right">+88</div>
				</li>
				<li class="xfei">
					<div class="box_left"> 
						<h3><span>消费</span>邀请新用户注册</h3>
						<i>2020-01-01 16:42</i>
					</div>
					<div class="box_right">+88</div>
				</li>
			</ul>
		</div>
		
		<!-- 暂无记录 -->
		<!-- <div class="jf_box">
			<div class="jf_img">
				<img src="../assets/wu.png" alt="">
			</div>
			<span>暂无积分变动记录!</span>
		</div> -->
	</div>
</template>

<script>
export default {
	name: 'Integral',
	data () {
		return {
			
		}
	},
	
}
</script>
<style scoped>
	#integral{
		min-height: 100vh;
		background-color: #fff;
	}
	.integral_box{
		background-image: -webkit-linear-gradient( 90deg, rgb(135,244,248) 0%, rgb(42,175,251) 100%, rgb(63,149,255) 100%, rgb(111,107,255) 100%);
		height: 3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		position: relative;
	}
	.integral_box::before{
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 1.5rem;
		background: url(../assets/jf_bg.png) no-repeat center;
		background-size: cover;
		opacity: .18;
	}
	.integral_box h2{
		font-size: .38rem;
		color: #fff;
		font-weight: 600;
	}
	.integral_box span{
		font-size: .28rem;
		color: #fff;
		display: block;
	}
	.jf_list{
		background-color: #fff;
		padding: .2rem;
	}
	.jf_list ul li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #eee;
		padding: .1rem;
		margin-bottom: .15rem;
	}
	.jf_list ul li .box_left h3{
		font-size: .26rem;
		color: #333;
		margin-bottom: .1rem;
	}
	.jf_list ul li .box_left h3 span{
		display: inline-block;
		margin-right: .1rem;
		padding: .03rem .08rem;
		border-radius: .06rem;
		color: #fff;
		font-size: .24rem;
	}
	.jf_list ul li .box_left i{
		font-size: .24rem;
		color: #666;
		display: block;
	}
	.jf_list ul li .box_right{
		font-size: .26rem;
	}
	.jf_list ul li.hd .box_left h3 span{
		background-color: #2AAFFB;
	}
	.jf_list ul li.hd .box_right{
		color: #2AAFFB;
	}
	.jf_list ul li.xfei .box_left h3 span{
		background-color: #f33a16;
	}
	.jf_list ul li.xfei .box_right{
		color: #f33a16;
	}
	.jf_box{
		padding: .2rem;
	}
	.jf_box .jf_img{
		width: 60%;
		margin: .8rem auto 0;
	}
	.jf_box .jf_img img{
		width: 100%;
		display: block;
	}
	.jf_box span{
		font-size: .24rem;
		color: #333;
		text-align: center;
		display: block;
		margin-top: .5rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/Integral.vue